

import qs from "qs";
import * as axiosHelper from "./api_helper";

export const getReports = async ({ payload }) => {
  const { reportType, ...params } = payload;
  const data = await axiosHelper.get(`/reports/${reportType}?${qs.stringify(params)}`);
  // Some report endpoints (e.g. mt5-operations with Deals) return a plain array
  // rather than a paginated object. Normalize to the shape reducers/components expect.
  if (Array.isArray(data.result)) {
    return {
      docs: data.result,
      totalDocs: data.result.length,
      totalPages: 1,
      page: 1,
      hasNextPage: false,
      hasPrevPage: false,
    };
  }
  return data.result;
};

export const downloadReport = async (payload) => {
  const { reportType, ...params } = payload;
  return await axiosHelper.get(`/reports/download/${reportType}?${qs.stringify(params)}`, { responseType: "blob" });
};

export const getAffiliateReports = async ({ payload, clientId }) => {
  const data = await axiosHelper.get(`/affiliate/${clientId}?${qs.stringify(payload)}`);
  return data.result;
};